import React from 'react';
import './BlogCard.css';

const BlogCard = ({ post, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(post);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <article
      className="blog-card-container"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-label={`Read article: ${post.title}`}
    >
      {/* Author Info */}
      {post.authors && (
        <div className="blog-card-author">
          {post.authors.map((author) => (
            <>
              <div className="blog-card-author-avatar">
                <img src={author.avatar} alt={author.name} />
              </div>
              <span className="blog-card-author-name">{author.name}</span>
            </>
          ))}
        </div>
      )}
      <div className="blog-card-main">
        <div className="blog-card-content">
          <h2 className="blog-card-title">{post.title}</h2>
          <p className="blog-card-excerpt">{post.excerpt}</p>
          
          <div className="blog-card-meta">
            <div className="blog-card-meta-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
              <span className="blog-card-meta-date">{post.date}</span>
            </div>
            
            {post.category && (
              <div className="blog-card-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                  <line x1="7" y1="7" x2="7.01" y2="7" />
                </svg>
                <span className="blog-card-meta-category">{post.category.charAt(0).toUpperCase() + post.category.slice(1).replace('-', ' ')}</span>
              </div>
            )}
          </div>
        </div>
        
        {/* Image for posts with images */}
        {post.image && (
          <div className="blog-card-image">
            <img src={post.image} alt={`Cover for ${post.title}`} />
          </div>
        )}
      </div>
    </article>
  );
};

export default BlogCard;
